// "paragraph_[0-9]?[0-9]": ?

import React from "react";
import styled from "styled-components";
import PopupLink from "../../PopupLink";

const MainHeader = styled.h1`
  font-size: 1.5em;
`;
// const SubHeader = styled.h2`
//   font-size: 1em;
// `
const ContentContainer = styled.div`
  font-size: 0.8em;
`;

const PopupContent = () => (
  <React.Fragment>
    <MainHeader> Taxes and Fees </MainHeader>
    <ContentContainer>
      <strong>Taxes and fees</strong>
      <p>
        The following taxes and fees may apply to airline ticket purchases. The
        actual taxes and fees for your purchase will be displayed during
        purchase.
      </p>
      <div>
        <strong>Government Imposed Taxes and Fees:</strong>
      </div>
      <p>
        <u>September 11th Security Fee:</u> $5.60 USD applies per one-way trip.
        There may be multiple one-way trips on the same itinerary.
      </p>
      <p>
        <u>Passenger Facility Charges:</u> Up to $18.00 USD depending on the
        itinerary.
      </p>
      <p>
        <u>Travel Facilities Tax:</u> Up to $17.40 USD per round-trip for
        domestic flights beginning or ending in Alaska or Hawaii.
      </p>
      <p>
        <u>Federal Domestic Flight Segment Fee:</u> $4.00 USD per flight
        segment. A flight segment is defined as one takeoff and one landing.
      </p>
      <p>
        <u>U.S. International Departure Tax:</u> $17.50 USD per departure
        applies to international tickets departing from the U.S.
      </p>
      <p>
        <u>U.S. International Arrival Taxes:</u> International flights arriving
        into the U.S. are assessed the following taxes - US International
        Arrival tax of $17.50 USD, US Customs fee of $5.50 USD, Immigration
        (INS) fee of $7.00 USD and Animal and Plant Health Inspection fee
        (APHIS) of $5.00 USD.
      </p>
      <p>
        <u>International Taxes:</u> International travel incurs additional
        international taxes, the amounts of which can vary dramatically
        depending upon routing and destination.
      </p>
      <p>
        <u>Entry/Exit Fees:</u> If you are traveling internationally, some
        countries (or airports) charge fees upon entering and/or exiting the
        country. These fees are not included in the ticket price, or the taxes
        and fees we display on our website prior to purchase. For more
        information on a specific country's entry/exit fee, we suggest that you
        visit{" "}
        <a href="http://www.travel.state.gov" target="_blank">
          www.travel.state.gov
        </a>{" "}
        prior to departure.
      </p>
      <strong>Airline Imposed Fees:</strong>
      <p>
        <u>Itinerary Changes/Cancellations/Refunds:</u> Post-purchase changes,
        when permitted, may carry airline-imposed change and/or cancellation
        fees. These fees will be displayed in your airline’s fare rules.
      </p>
      <p>
        <u>Baggage Fees and Optional Services:</u> Airline baggage fees and
        optional services vary by airline, flight and frequent flyer status.
        These fees are not included in your airline ticket cost. Please visit
        the Baggage Fees and Optional Services link on your itinerary for
        details.
      </p>
      <p>
        <u>Airline Surcharge:</u> For many international destinations, airlines
        impose a surcharge. This could include either a fuel or security
        surcharge. The amount varies widely depending on the destination and/or
        carrier. Some airlines include surcharges in their ticket cost. The most
        common surcharges are either fuel or security surcharges. The amount
        varies widely depending on both the carrier and the itinerary. When
        applicable, this amount is included in your airline ticket cost.
      </p>
      <strong>Our Fees:</strong>
      <p>
        <u>Processing Fees:</u> A non-refundable per ticket processing fee will
        be applied to reservations that include multiple airlines and will be
        displayed as a Processing Fee on your Contract page.
      </p>
      <p>
        <u>Paper Ticket Fees:</u> A $34.95 USD shipping and handling fee will be
        charged if your itinerary requires the issuance of paper tickets. If
        your tickets are rerouted or are undeliverable and are returned, there
        will be an additional $34.95 USD re-handling fee.
      </p>
      <p>
        <u>Itinerary Changes/Cancellations/Refunds:</u> If airline fare rules
        allow itinerary changes or cancellations for a fee, a $30 USD per ticket
        exchange processing fee will also apply (if non-US currency used, fee
        will be converted at time of exchange). This fee is not included in the
        ticket price or the taxes and fees we display on our website. The total
        cost of the ticket, including taxes and fees, is disclosed prior to
        purchase. By making reservations on this site, you agree to abide by the
        policies described herein as well as the Terms and Conditions governing
        your use of this site.
      </p>
    </ContentContainer>
  </React.Fragment>
);

function PPNFeesLink({ linkText }) {
  return (
    <PopupLink
      // defaultOpen={true}
      linkText={linkText}
      popupContent={<PopupContent />}
    />
  );
}

export default PPNFeesLink;



// WEBPACK FOOTER //
// ./src/components/ChargesSummaryTable/PPNFeesLink/index.js